<!--
 * @Author: your name
 * @Date: 2021-07-24 17:28:22
 * @LastEditTime: 2026-03-06 10:40:25
 * @LastEditors: YangHan 1047143112@qq.com
 * @Description: In User Settings Edit
 * @FilePath: \kares_pad\src\components\schedule\windows\children\TerminalList.vue
-->

<template>
  <div class="terminal-list">
    <msg-dialog :dialogVisible="terminalListDV" @closeDialog="TerminalCD" dWidth="1100px"
      :title="$t('PE.SelectTerminal')">
      <div v-loading="loading" element-loading-text="拼命发布中，请稍后..." element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="equipment">
          <div class="equipment-left">
            <trees type="GROUP" @getAssets="getAssets" :list="groupList"></trees>
          </div>
          <div class="equipment-right">
            <!-- <div>搜索</div> -->
            <div class="device-table">
              <el-table ref="multipleTable" :data="deviceList" :row-key="(row) => row.id"
                @selection-change="deviceSelect" @row-click="tableRowClick">
                >
                <el-table-column type="selection" width="60" :reserve-selection="true"></el-table-column>
                <el-table-column prop="name" :label="$t('PE.TerminalName')"></el-table-column>
                <el-table-column prop="group_name" :label="$t('PE.Structure')"></el-table-column>
                <!-- <el-table-column prop="type_remark" :label="$t('PE.DeviceType')"></el-table-column> -->
                <el-table-column :label="$t('PE.DeviceStatus')" width="140">
                  <div slot-scope="scope" v-if="scope.row.run_state"
                    v-html="runState(scope.row.run_state, scope.row.group_run_status)"></div>
                  <div v-else>
                    <span style="color: #ea1a1a;">{{ $t('PE.Offline') }}</span>
                  </div>
                </el-table-column>
                <el-table-column prop="size_remark" :label="$t('PE.Resolution')" width="140"></el-table-column>
              </el-table>
            </div>
            <div class="flex-b-c device-control">
              <div>
                <el-checkbox v-model="selectAll" @change="changeAll">{{ $t('terminal.allSelect') }}</el-checkbox>
                <span style="padding: 16px;" v-show="deviceSelectList.length">{{ $t('terminal.selected') }}({{
                  deviceSelectList.length }})</span>
              </div>
              <!-- <div>
                <el-input placeholder="请输入终端名称" v-model="keyword" size="mini" @input="keywordInput">
                  <i slot="suffix" class="el-input__icon el-icon-search icon" @click="getKeywordList(keyword)"></i>
                </el-input>
              </div> -->
              <div class="flex-b-c">
                <el-input :placeholder="$t('cswctl4')" v-model="keyword" size="mini" @input="keywordInput">
                  <i slot="suffix" class="el-input__icon el-icon-search icon" @click="getKeywordList(keyword)"></i>
                </el-input>
                <pagination :page="this.page" :pagerCount="5" :current="current" :limit="limit"
                  @currentChange="currentChange"></pagination>
              </div>
              <!-- <span></span> -->
            </div>
          </div>
        </div>
        <div class="footer">
          <div class="button">
            <el-button round @click="cancel">{{ $t('basics.Cancel') }}</el-button>
            <el-button round type="primary" @click="confirm" :disabled="this.deviceSelectList.length == 0">{{
              $t('basics.Confirm') }}</el-button>
          </div>
          <div class="append" v-if="isPlay">
            <div class="checkb">
              <el-checkbox v-model="adapterScreen">{{ $t('PE.AdaptiveScreen') }}</el-checkbox>
            </div>
            <el-select v-model="isAppend" size="mini" style="width: 120px;" :placeholder="$t('basics.PleaseSelect')"
              v-if="append">
              <el-option v-for="item in publishType" :key="item.value" :label="item.label"
                :value="item.value"></el-option>
            </el-select>
          </div>
        </div>
      </div>
    </msg-dialog>
    <msg-dialog :dialogVisible="publishNameDv" @closeDialog="publishNameCD" :title="$t('nswct01')" :modalAppend="false">
      <div class="flex-a-c" style="margin-bottom: 16px;">
        <div style="width: 100px">{{ $t('nswct01') }}: </div><el-input v-model="publishName"
          :placeholder="$t('nswct02')"></el-input>
      </div>
      <div class="flex-a-c">
        <el-button round @click="publishNameCD">{{ $t('basics.Cancel') }}</el-button>
        <el-button round type="primary" @click="confirm">{{ $t('basics.Confirm') }}</el-button>
      </div>
    </msg-dialog>
  </div>
</template>

<script>
// this.$emit("publishTerminal", this.deviceSelectList, this.adapterScreen, this.isAppend);
/**
 * @description: 设备选择发布
 * @param {选中设备列表} 参数1
 * @param {是否自适应屏幕有} 参数2
 * @param {覆盖追加发布}} 参数3
 * @return {*}
 */

import MsgDialog from '@/components/basics/FormDialog'
import { mPagination } from "@/components/basics/mixins";
import trees from '@/components/basics/Trees'
import pagination from '@/components/basics/Pagination'
import { runStateInfo } from "@/assets/scripts/runState"
import { changeDeviceStateName } from "@/assets/scripts/changeDeviceStateName";
export default {
  name: 'TerminalList',
  mixins: [mPagination],
  props: {
    terminalListDV: {
      type: Boolean,
      default: false
    },
    diffIsAppend: {
      type: Number,
      default: 0
    },
    append: {
      type: Boolean,
      default: false
    },
    defaultPName: {
      type: String,
      default: ''
    },
    isPlay: {
      type: Boolean,
      default: true
    },

  },
  data() {
    return {
      groupList: [],
      deviceList: [],
      deviceAllList: [],
      deviceSelectList: [],
      adapterScreen: false,
      isAppend: '0',
      selectAll: false,
      loading: false,
      keyword: "",
      publishType: [
        { value: '0', label: this.$t('cscg14') },
        { value: '1', label: this.$t('cscg15') }
      ],
      publishNameDv: false,
      publishName: "",
    }
  },
  created() {
    this.getGroupList();
    this.getDeviceListAll();
  },
  methods: {
    init() {
      this.selectAll = false;
      this.loading = false;
      this.deviceSelectList = [];
      this.page = 1;
      this.deviceList = this.deviceAllList.slice((this.page - 1) * this.limit, this.page * this.limit);
    },
    publishNameCD() {
      this.publishNameDv = false;
      this.publishName = '';
    },
    cancel() {
      this.$emit("publishTerminal", []);
    },
    async confirm() {

      if (this.defaultPName && this.publishName === "") {
        this.publishName = this.defaultPName;
        // this.publishNameDv = true;
        // return;
      }

      this.publishNameDv = false;

      let append = 0;
      this.append ? append = this.isAppend : append = this.diffIsAppend;
      this.loading = true;
      this.$emit("publishTerminal", this.deviceSelectList, this.adapterScreen, append, this.publishName);
    },
    TerminalCD() {
      this.adapterScreen = false;
      this.$emit("publishTerminal", []);
    },
    //组织结构切换重新加载关联设备
    getAssets(ids) {
      if (ids.type === "GROUP") {
        this.groupIds = ids.ids;
      }
      this.currentChange(1);
    },
    getKeywordList(keyword) {
      const list = this.getDeviceList().filter(d => d.name.includes(keyword));
      this.page = 1;
      this.current = list.length;
      this.deviceList = list.slice((this.page - 1) * this.limit, this.page * this.limit);
    },
    keywordInput(keyword) {
      if (!keyword) {
        this.currentChange(1);
      }
    },
    getGroupList() {
      this.$http.post("/admin/access/groupList", {}, data => {
        this.groupList = data;
      });
    },
    currentChange(val) {
      this.page = val;
      let list = [];
      if (this.keyword) {
        list = this.getDeviceList().filter(d => d.name.includes(this.keyword));
      } else {
        list = this.getDeviceList();
      }
      this.current = list.length;
      this.deviceList = list.slice((this.page - 1) * this.limit, this.page * this.limit);
    },
    runState(rt, gt) {
      let rti = runStateInfo(rt, gt);
      rti = changeDeviceStateName(rti);
      return `<span style="color: ${rti.stateColor};">${this.$t(rti.stateName)}</span>`;
    },
    getDeviceListAll(device = {
      group_ids: this.groupIds,
      limit: 9999,
    }) {
      this.$http.post("/admin/device/list", device, data => {
        this.deviceAllList = data.list;
        this.deviceList = this.deviceAllList.slice((this.page - 1) * this.limit, this.page * this.limit);
        this.current = parseInt(data.count);
      });
    },
    getDeviceList() {
      const ids = this.groupIds.split(",");
      return this.deviceAllList.filter(d => ids.find(id => id == d.group_id));
    },
    changeAll(val) {
      if (val) {
        const list = this.getDeviceList();
        list.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row, true);
        });
      } else {
        this.selectAll = false;
        this.$refs.multipleTable.clearSelection();
      }
    },
    deviceSelect(val) {
      this.deviceSelectList = val;
    },
    tableRowClick(row) {
      this.$refs.multipleTable.toggleRowSelection(row);
    },
  },
  watch: {
    terminalListDV: {
      handler(nd) {
        nd && this.init();
      }
    }
  },
  components: {
    MsgDialog,
    trees,
    pagination
  }
}
</script>

<style lang="scss" scoped>
.terminal-list {
  .equipment {
    display: flex;
    height: 500px;

    .equipment-left {
      flex: 0 0 240px;
      border: 1px solid #edfbff;
      border-radius: 8px;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .equipment-right {
      margin-left: 8px;
      flex: 1;
      border-radius: 8px;

      .device-table {
        height: calc(100% - 40px);
        overflow-y: auto;
      }

      .device-control {
        position: relative;

        /deep/ .el-input__inner {
          border-radius: 20px;
        }
      }
    }

    /deep/ .el-table__header-wrapper {
      .cell {
        font-size: 18px;
        color: var(--theme-color-customized-1);
      }

      th:last-child>.cell {
        text-align: center;
      }
    }
  }

  .footer {
    width: 100%;
    height: 60px;
    position: relative;

    .button {
      position: absolute;
      left: 50%;
      top: 50%;
      transform: translate(-50%, -50%);
    }

    .append {
      width: 300px;
      position: absolute;
      top: 50%;
      right: 20px;
      transform: translateY(-50%);
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
  }
}
</style>

<style>
.el-notification {
  z-index: 3000 !important;
}
</style>
